export const LOGIN_PREFILL_STORAGE_KEY = 'jangi.loginPrefill'

export type LoginPrefill = {
  userId: string
  password: string
}

export function saveLoginPrefill(credentials: LoginPrefill) {
  sessionStorage.setItem(LOGIN_PREFILL_STORAGE_KEY, JSON.stringify(credentials))
}

export const SIGNUP_DONE_STORAGE_KEY = 'jangi.signupDone'

export type SignupDonePrefill = {
  name: string
  userId: string
}

export function saveSignupDone(snapshot: SignupDonePrefill) {
  sessionStorage.setItem(SIGNUP_DONE_STORAGE_KEY, JSON.stringify(snapshot))
}

export function readSignupDone(): SignupDonePrefill | null {
  const raw = sessionStorage.getItem(SIGNUP_DONE_STORAGE_KEY)
  if (!raw) {
    return null
  }

  try {
    const parsed = JSON.parse(raw) as SignupDonePrefill
    if (!parsed.name || !parsed.userId) {
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export function consumeLoginPrefill(): LoginPrefill | null {
  const raw = sessionStorage.getItem(LOGIN_PREFILL_STORAGE_KEY)
  if (!raw) {
    return null
  }

  sessionStorage.removeItem(LOGIN_PREFILL_STORAGE_KEY)

  try {
    const parsed = JSON.parse(raw) as LoginPrefill
    if (!parsed.userId || !parsed.password) {
      return null
    }
    return parsed
  } catch {
    return null
  }
}
